/** API activity_status values (same as backend ACTIVITY_STATUS). */
export const DRIVER_ACTIVITY_STATUS = Object.freeze({
    ACTIVE: 'active',
    INACTIVE: 'inactive',
    PAUSE: 'pause',
    BUSY: 'busy',
});

/** Single place for activity_status → UI label. */
export const DRIVER_ACTIVITY_STATUS_LABEL = Object.freeze({
    [DRIVER_ACTIVITY_STATUS.ACTIVE]: 'Aktivan',
    [DRIVER_ACTIVITY_STATUS.INACTIVE]: 'Neaktivan',
    [DRIVER_ACTIVITY_STATUS.PAUSE]: 'Pauza',
    [DRIVER_ACTIVITY_STATUS.BUSY]: 'Zauzet',
});

export const DRIVER_STATUS_ACTIVE =
    DRIVER_ACTIVITY_STATUS_LABEL[DRIVER_ACTIVITY_STATUS.ACTIVE];
export const DRIVER_STATUS_INACTIVE =
    DRIVER_ACTIVITY_STATUS_LABEL[DRIVER_ACTIVITY_STATUS.INACTIVE];
export const DRIVER_STATUS_BUSY =
    DRIVER_ACTIVITY_STATUS_LABEL[DRIVER_ACTIVITY_STATUS.BUSY];
export const DRIVER_STATUS_PAUSE =
    DRIVER_ACTIVITY_STATUS_LABEL[DRIVER_ACTIVITY_STATUS.PAUSE];
export const DRIVER_ON_STAND_LABEL = 'Na štandu';

const DRIVER_ACTIVITY_STATES = new Set(Object.values(DRIVER_ACTIVITY_STATUS));

/** Normalized state from API activity_status: active | busy | pause | inactive */
export const getDriverActivityState = (value) => {
    const status = String(value ?? '').trim().toLowerCase();
    return DRIVER_ACTIVITY_STATES.has(status)
        ? status
        : DRIVER_ACTIVITY_STATUS.INACTIVE;
};

/** Label for a raw activity_status value. */
export const getDriverActivityStatusLabel = (value) => {
    const state = getDriverActivityState(value);
    return DRIVER_ACTIVITY_STATUS_LABEL[state];
};

/** Online = not inactive: active, busy, or pause. */
export const isDriverOnline = (driver) =>
    getDriverActivityState(driver?.activity_status) !==
    DRIVER_ACTIVITY_STATUS.INACTIVE;

/** busy | pause | null */
export const getDriverExtraStatus = (driver) => {
    const state = getDriverActivityState(driver?.activity_status);
    return state === DRIVER_ACTIVITY_STATUS.BUSY ||
        state === DRIVER_ACTIVITY_STATUS.PAUSE
        ? state
        : null;
};

export const getDriverStatusLabel = (driver) =>
    getDriverActivityStatusLabel(driver?.activity_status);

export const getDriverStatusModifier = (driver) =>
    getDriverActivityState(driver?.activity_status);

export const isDriverOnStand = (driver) => driver?.stand_id != null;
export const REACT_APP_REFRESH_INTERVAL = 10000;
